// import { getQrcodeByAuthcode } from '@/api/qrcode'

export default {
  state: {
    qrcode: null
  },
  mutations: {
    SET_QRCODE(state, value) {
      state.qrcode = value
    }
  },
  actions: {
    getQrcodeByAuthcode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        // getQrcodeByAuthcode(payload)
        //   .then((res) => {
        //     if (res.success) {
        //       commit('SET_QRCODE', res.body)
        //       resolve(res)
        //     }
        //   })
        //   .catch((err) => {
        //     reject(err)
        //   })
      })
    }
  }
}
